export const ShipmentLoadUsers = [
  'az.dsp.01@facti.com.mx',
  'az.dsp.02@facti.com.mx',
];
